var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-btn',_vm._g(_vm._b({staticClass:"btn-circle",attrs:{"size":"sm","variant":"outline-primary"}},'b-btn',_vm.$attrs,false),_vm.$listeners),[_c('fa',{attrs:{"icon":("chevron-" + (_vm.left ? 'left' : 'right'))}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }